export enum SessionPathsEnum {
  SESSION = "/session/:id",
}
